import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { projectTaskMileStonetCreationService } from "../../../services/projectDetails";

export default function MileStoneModal({ setModal, setOnRender, onRender }) {
  const [mileStoneTitle, setMileStoneTitle] = useState("");
  const [mileStoneDescription, setMileStoneDescription] = useState("");
  const [nameError, setNameError] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const DetailedProjectData = useSelector(
    (state) => state.projectDetails.getDetailedProjectData
  );

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleMileStoneCreation = async () => {
    if (mileStoneTitle === "") {
      return setNameError("Milestone Name Required!");
    }

    setLoading(true);

    try {
      const responseData = await projectTaskMileStonetCreationService({
        project_id: DetailedProjectData.project._id,
        title: mileStoneTitle,
        description: mileStoneDescription,
      });

      if (responseData && responseData.status === 200) {
        toast.success(responseData?.data?.message);
        setModal(false);
        setOnRender(!onRender);
      } else {
        toast.error(responseData.message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleTitle = (e) => {
    setMileStoneTitle(e.target.value);
    if (e.target.value === "") {
      setNameError("Milestone Name Required!");
    } else {
      setNameError("");
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      setModal(false);
    }, 300);
  };

  return (
    <div
      className="pd-theme relative z-10 "
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-theme-ink transition-opacity duration-300 ease-in-out z-20
          ${isVisible ? "opacity-50" : "opacity-0"}
        `}
        onClick={handleClose}
      />

      {/* Modal container */}
      <div
        className={`fixed inset-0 z-30 w-auto flex items-center justify-center transition-all duration-300 ease-in-out transform
          ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}
        `}
      >
        <div className="relative rounded-theme-xl bg-theme-paper text-left shadow-theme-pop max-w-[320px] sm:w-full sm:max-w-lg">
          <div className="bg-theme-paper p-6 rounded-theme-xl">
            <div className="flex justify-end">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                onClick={handleClose}
                stroke="currentColor"
                className="w-6 h-6 cursor-pointer text-theme-fg-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>

            <div className="modal-body relative">
              <label className="text-sm font-semibold text-theme-fg-2">Milestone Name</label>
              <input
                className="p-3 w-full text-sm outline-none rounded-theme-sm border border-theme-cream-3 text-theme-fg-1 focus:border-theme-accent mt-1 mb-[2px]"
                type="text"
                placeholder="Enter Milestone name"
                onChange={handleTitle}
              />
              <p className="text-xs text-theme-full-fg font-thin ml-1">{nameError}</p>

              <br />
              <label className="text-sm font-semibold text-theme-fg-2">Description</label>
              <div className="flex items-start rounded-theme-sm border border-theme-cream-3 mt-1 mb-5 w-full">
                <div className="p-3 pr-0">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2 3H13C13.2652 3 13.5196 3.10536 13.7071 3.29289C13.8946 3.48043 14 3.73478 14 4C14 4.26522 13.8946 4.51957 13.7071 4.70711C13.5196 4.89464 13.2652 5 13 5H2C1.73478 5 1.48043 4.89464 1.29289 4.70711C1.10536 4.51957 1 4.26522 1 4C1 3.73478 1.10536 3.48043 1.29289 3.29289C1.48043 3.10536 1.73478 3 2 3ZM2 7H13C13.2652 7 13.5196 7.10536 13.7071 7.29289C13.8946 7.48043 14 7.73478 14 8C14 8.26522 13.8946 8.51957 13.7071 8.70711C13.5196 8.89464 13.2652 9 13 9H2C1.73478 9 1.48043 8.89464 1.29289 8.70711C1.10536 8.51957 1 8.26522 1 8C1 7.73478 1.10536 7.48043 1.29289 7.29289C1.48043 7.10536 1.73478 7 2 7ZM2 11H8C8.26522 11 8.51957 11.1054 8.70711 11.2929C8.89464 11.4804 9 11.7348 9 12C9 12.2652 8.89464 12.5196 8.70711 12.7071C8.51957 12.8946 8.26522 13 8 13H2C1.73478 13 1.48043 12.8946 1.29289 12.7071C1.10536 12.5196 1 12.2652 1 12C1 11.7348 1.10536 11.4804 1.29289 11.2929C1.48043 11.1054 1.73478 11 2 11Z"
                      fill="#8A8A82"
                    />
                  </svg>
                </div>

                <textarea
                  className="p-2 w-full text-sm outline-none text-theme-fg-1"
                  placeholder="Enter task description"
                  onChange={(e) => setMileStoneDescription(e.target.value)}
                />
              </div>

              <button
                onClick={handleMileStoneCreation}
                disabled={loading}
                className={`mb-4 p-3 px-5 w-full ${
                  loading
                    ? "bg-theme-cream-3 cursor-not-allowed"
                    : "bg-theme-ink hover:bg-theme-ink-2"
                } text-sm text-white font-semibold rounded-theme-sm flex items-center justify-center`}
              >
                {loading ? (
                  <div className="w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin"></div>
                ) : (
                  "Create Milestone"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
